import Layers from "slotworks/graphics/layers/layers";
import currency from "slotworks/i18n/currency";
import betModel from "slotworks/model/bets/bet-model";

export default class JackpotMeterComponent {

    private jackpotValues: Map<number, number>;

    constructor() {
        this.jackpotValues = new Map();                
    }

    setJackpot(key: number) {        
        const value = this.getValue(key);   
        const jackpot = Layers.MatrixBackground.getBitmapText("jackpot");
        jackpot.text = currency.format(value, undefined, undefined, true);   
    }

    setValues(values: any) {        
        for(let bet in values) {
            const key:number = parseInt(bet, 10);
            this.jackpotValues.set(key, values[bet]);
        }
        this.setJackpot(betModel.getTotalBet());
    }

    // this function will retrn the backend jackpot value or base reset value (bet * 2000)
    getValue(key: number) {
        if(this.jackpotValues.has(key))            
            return this.jackpotValues.get(key);
        else 
            return key * 2000; // base reset value
    }

    setEmpty() {
        const jackpot = Layers.MatrixBackground.getBitmapText("jackpot");
        jackpot.text = ""; 
    }
}